module.exports = __webpack_public_path__ + "static/media/2019-sh.a516ef49.jpg";